<template>
<div id="page-dialogs">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6 lg6>
        <base-material-card color="primary" icon="library_books" title="Cambiar Contraseña" class="elevation-1 px-5 py-3">

          <v-card-text>
            <v-form>
              <v-container grid-list-md text-xs-center @keyup.enter="actualizar()">
                <v-text-field autocomplete="new-password" :append-icon="iconpass1" @click:append="mostrarPass1" :rules="[rules.required]" name="login" label="Contrseña Anterior" :type="passwordFieldType1" v-model="model.pass_old"></v-text-field>
                <v-text-field autocomplete="new-password" :append-icon="iconpass2" @click:append="mostrarPass2" :rules="[rules.required]" name="login" label="Ingresar Nueva Contrseña" :type="passwordFieldType2"
                  v-model="model.pass_new"></v-text-field>
                <v-text-field autocomplete="new-password" :append-icon="iconpass3" :rules="[rules.required]" @click:append="mostrarPass3" name="password" label="Confirmar Nueva Contraseña" :type="passwordFieldType3"
                  v-model="model.pass_confirm"></v-text-field>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-chip v-if="model.pass_confirm != model.pass_new" outlined color="red"><v-icon color="red"> error</v-icon>Contraseñas no
              coinciden..</v-chip>
            <v-spacer></v-spacer>
            <v-btn block color="primary" v-bind:disabled="
                  model.pass_confirm === '' ||
                    model.pass_confirm != model.pass_new
                " @click="actualizar" :loading="loading">Actualizar</v-btn>
          </v-card-actions>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
export default {
  created: async function() {
    this.URL = this.$hostname + "carta_porte/administracion/";
    await this.getUsuario();
  },
  data: () => ({
    fab: false,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Cambiar Contraseña",
        disabled: true,
        href: ""
      }
    ],
    loading: false,
    passwordFieldType1: "password",
    passwordFieldType2: "password",
    passwordFieldType3: "password",
    iconpass1: "fa-eye",
    iconpass2: "fa-eye",
    iconpass3: "fa-eye",
    rules: {
      required: value => !!value || "El campo no puede ir vacio"
    },
    model: {
      pass_old: "",
      pass_new: "",
      pass_confirm: ""
    },
    usr: null
  }),

  methods: {
    getUsuario: function() {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var uuid_usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_usuario")));
      this.$axios.post(this.URL + "list_usuarios/", {"filtros": {"uuid": uuid_usuario}})
        .then(res => {
          this.usr = res.data[0];
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener el usuario.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    mostrarPass1: function(evt) {
      this.passwordFieldType1 =
        this.passwordFieldType1 === "password" ? "text" : "password";
      this.iconpass1 =
        this.passwordFieldType1 === "password" ? "fa-eye" : "fa-eye-slash";
    },
    mostrarPass2: function(evt) {
      this.passwordFieldType2 =
        this.passwordFieldType2 === "password" ? "text" : "password";
      this.iconpass2 =
        this.passwordFieldType2 === "password" ? "fa-eye" : "fa-eye-slash";
    },
    mostrarPass3: function(evt) {
      this.passwordFieldType3 =
        this.passwordFieldType3 === "password" ? "text" : "password";
      this.iconpass3 =
        this.passwordFieldType3 === "password" ? "fa-eye" : "fa-eye-slash";
    },
    actualizar() {
      var self = this;

      var pass_old = this.$crypto.SHA256(this.model.pass_old);
      if (pass_old != this.usr.password) {
        this.$swal({
          type: "error",
          title: "Error",
          text: "La contraseña anterior no es correcta.",
          footer: "",
        });
        return;
      }
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var data = {
        uuid: this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_usuario"))),
        password: this.$crypto.SHA256(this.model.pass_new)
      }
      this.$axios.post(this.URL + "update_usuario/", data)
        .then(res => {
          self.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "El registro se guardó correctamente.",
            footer: "",
          });
          self.modal = false;
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al guardar el registro.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.$root.$dialogLoader.hide();
        });
      // this.$router.push('/pass');
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
